<template>
  <main>
    <!-- <button @click="getAutomaticProcessesStatus()">holi</button> -->
    <div class="row">
      <h2 class="d-none d-md-block col-md-auto">
        Administrador de procesos automáticos
      </h2>
      <i
        class="fa my-2 ml-2 mt-md-1 fa-question-circle text-info info-ico"
        aria-hidden="true"
        @click="showInfoSwals()"
      ></i>
      <h2 class="d-md-none col-8">Procesos Automáticos</h2>
    </div>
    <div class="d-flex flex-row flex-wrap">
      <div class="col-12 col-md-4">
        <div class="card">
          <p class="card-body">
            <badge
              class=""
              slot="title-label"
              :type="
                automaticProcessesStatus.notifyExpiration ? `success` : `danger`
              "
            >
              <span
                :class="automaticProcessesStatus.notifyExpiration ? '' : ''"
              >
                {{
                  automaticProcessesStatus.notifyExpiration
                    ? `encendido`
                    : `apagado`
                }}
              </span>
            </badge>
          </p>
          <h4 slot="header" class="card-header mt-0 pt-0">
            Notificar Vencimientos
          </h4>
          <hr class="mt-0 mx-3" />

          <p class="card-body">
            Este proceso automático envía correos electrónicos a los socios para
            informarles sobre el vencimiento próximo de sus membresías.
            <br />
            Puedes configurar un máximo de
            <span class="text-danger font-weight-bold">15</span> días para
            comenzar las notificaciones
          </p>
          <div class="d-flex flex-row">
            <small class="font-weight-bold my-auto col-7"
              >Días para comenzar a notificar</small
            >
            <div class="col-5">
              <div
                class="mx-auto rounded-lg d-flex"
                :class="
                  automaticProcessesStatus.notifyExpiration &&
                  !notifyExpirationIsLoading
                    ? 'card-notificationdays text-secondary'
                    : 'card-notificationdays--disabled text-danger'
                "
                @click="
                  automaticProcessesStatus.notifyExpiration &&
                  !notifyExpirationIsLoading
                    ? updateDaysToNotifyExp()
                    : ''
                "
              >
                <h1 class="m-auto font-weight-bolder">
                  {{ notifyExpiration.days }}
                </h1>
              </div>
            </div>
          </div>
          <div class="card-body">
            <el-tooltip :open-delay="200" placement="top" class="">
              <template #content>{{
                automaticProcessesStatus.notifyExpiration
                  ? `Pausar Proceso Automático`
                  : `Iniciar Proceso Automatico`
              }}</template>
              <button
                class="btn col-12 p-2"
                :class="
                  automaticProcessesStatus.notifyExpiration
                    ? `btn-success`
                    : `btn-danger`
                "
                :disabled="notifyExpirationIsLoading"
                @click="
                  automaticProcessesStatus.notifyExpiration
                    ? handleAutomaticProcessDeactivation(
                        `JOB_NotificarVencimientos`,
                        `notifyExpiration`
                      )
                    : handleAutomaticProcessActivation(
                        `JOB_NotificarVencimientos`,
                        `notifyExpiration`
                      )
                "
              >
                <h2 class="p-0 m-0">
                  <div
                    v-if="notifyExpirationIsLoading"
                    class="spinner-border"
                    role="status"
                  >
                    <span class="sr-only">Loading...</span>
                  </div>
                  <i
                    v-else
                    :class="
                      automaticProcessesStatus.notifyExpiration
                        ? `fa fa-forward pulse-animation`
                        : `fa fa-pause`
                    "
                  ></i>
                </h2>
              </button>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-4">
        <div class="card">
          <p class="card-body">
            <badge
              class=""
              slot="title-label"
              :type="
                automaticProcessesStatus.secondaryMembershipActivation
                  ? `success`
                  : `danger`
              "
            >
              <span
                :class="
                  automaticProcessesStatus.secondaryMembershipActivation
                    ? ''
                    : ''
                "
              >
                {{
                  automaticProcessesStatus.secondaryMembershipActivation
                    ? `encendido`
                    : `apagado`
                }}
              </span>
            </badge>
          </p>
          <h4 slot="header" class="card-header mt-0 pt-0">
            Activar membresías secundarias
          </h4>
          <hr class="mt-0 mx-3" />
          <p class="card-body">
            Este proceso activa automáticamente las membresías etiquetadas como
            [<span class="text-danger">SECUNDARIA</span>] que se encuentren en
            estado [<span class="text-danger">PAGADO</span>], siempre que la
            membresía principal correspondiente esté [<span class="text-danger"
              >PENDIENTE</span
            >].
          </p>
          <div class="card-body">
            <el-tooltip :open-delay="200" placement="top" class="">
              <template #content>{{
                automaticProcessesStatus.secondaryMembershipActivation
                  ? `Pausar Proceso Automático`
                  : `Iniciar Proceso Automatico`
              }}</template>
              <button
                class="btn col-12 p-2"
                :class="
                  automaticProcessesStatus.secondaryMembershipActivation
                    ? `btn-success`
                    : `btn-danger`
                "
                :disabled="secondaryMembershipActivationIsLoading"
                @click="
                  automaticProcessesStatus.secondaryMembershipActivation
                    ? handleAutomaticProcessDeactivation(
                        `JOB_ActivarMembresiasSecundarias`,
                        `secondaryMembershipActivation`
                      )
                    : handleAutomaticProcessActivation(
                        `JOB_ActivarMembresiasSecundarias`,
                        'secondaryMembershipActivation'
                      )
                "
              >
                <h2 class="p-0 m-0">
                  <div
                    v-if="secondaryMembershipActivationIsLoading"
                    class="spinner-border"
                    role="status"
                  >
                    <span class="sr-only">Loading...</span>
                  </div>
                  <i
                    v-else
                    :class="
                      automaticProcessesStatus.secondaryMembershipActivation
                        ? `fa fa-forward pulse-animation`
                        : `fa fa-pause`
                    "
                  ></i>
                </h2>
              </button>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-4">
        <div class="card">
          <p class="card-body">
            <badge
              class=""
              slot="title-label"
              :type="
                automaticProcessesStatus.normalizeMemerships.statusAA ||
                automaticProcessesStatus.normalizeMemerships.statusFI
                  ? `success`
                  : `danger`
              "
            >
              <span
                :class="automaticProcessesStatus.notifyExpiration ? '' : ''"
              >
                {{
                  automaticProcessesStatus.normalizeMemerships.statusAA ||
                  automaticProcessesStatus.normalizeMemerships.statusFI
                    ? `encendido`
                    : `apagado`
                }}
              </span>
            </badge>
          </p>
          <h4 slot="header" class="card-header mt-0 pt-0">
            Activar Membresias Pagadas
          </h4>
          <hr class="mt-0 mx-3" />
          <div class="card-body">
            <p class="">
              Activa las membresías marcadas como
              <span class="text-danger">PAGADO</span>. Puedes activarlas en
              función de la fecha de inicio configurada en cada membresía, o
              establecer un número de días desde su asignación para la activación automática de
              aquellas que no cuenten con una fecha de inicio definida.
            </p>

            <div class="d-flex flex-row">
              <div class="col-7 my-auto">
                <small class="font-weight-bold my-auto text-nowrap"
                  >Activar Por fecha de inicio</small
                >
              </div>
              <div class="d-flex col-5">
                <el-tooltip :open-delay="200" placement="top">
                  <template #content>
                    {{
                      automaticProcessesStatus.normalizeMemerships.statusFI
                        ? `Pausar Proceso Automático`
                        : `Iniciar Proceso Automatico`
                    }}
                  </template>
                  <button
                    class="w-auto btn mx-auto"
                    :class="
                      automaticProcessesStatus.normalizeMemerships.statusFI
                        ? 'btn-success'
                        : 'btn-danger'
                    "
                    @click="
                      automaticProcessesStatus.normalizeMemerships.statusFI
                        ? handleActivateMembershipsDeactivation(1)
                        : handleActivateMembershipsActivation(1)
                    "
                    :disabled="statusFIIsLoading"
                  >
                    <div
                      v-if="statusFIIsLoading"
                      class="spinner-border spinner-border-sm"
                      role="status"
                    >
                      <span class="sr-only">Loading...</span>
                    </div>
                    <i
                      v-else
                      class="fa fa-lg fa-fw"
                      :class="
                        automaticProcessesStatus.normalizeMemerships.statusFI
                          ? 'fa-refresh fa-spin'
                          : 'fa-pause'
                      "
                    ></i>
                  </button>
                </el-tooltip>
              </div>
            </div>
            <hr class="mt-1 mx-4 mb-2" />
            <div class="d-flex flex-row mb-2">
              <div class="col-7 d-flex flex-column my-auto">
                <small class="font-weight-bold text-nowrap mb-1"
                  >Activación Automática en:
                </small>
                <div class="w-100 d-flex justify-content-center">
                  <div
                    class="rounded-lg d-flex mr-1"
                    :class="
                      automaticProcessesStatus.normalizeMemerships.statusAA &&
                      !statusAAIsLoading
                        ? 'card-activationdays text-secondary'
                        : 'card-activationdays--disabled text-danger'
                    "
                    @click="
                      automaticProcessesStatus.normalizeMemerships.statusAA &&
                      !statusAAIsLoading
                        ? updateDaysToActivate()
                        : ''
                    "
                  >
                    <h2
                      class="m-auto font-weight-bolder"
                      :class="
                        String(
                          automaticProcessesStatus.normalizeMemerships.days
                        ).length > 1
                          ? 'px-2'
                          : ''
                      "
                    >
                      {{ automaticProcessesStatus.normalizeMemerships.days }}
                    </h2>
                  </div>
                  <small class="font-weight-bold my-auto ml-1">días</small>
                </div>
              </div>
              <div class="col-5 d-flex flex-column">
                <el-tooltip :open-delay="200" placement="top" class="">
                  <template #content>{{
                    automaticProcessesStatus.normalizeMemerships.statusAA
                      ? `Pausar Proceso Automático`
                      : `Iniciar Proceso Automatico`
                  }}</template>
                  <button
                    class="w-auto btn mb-0 mt-auto mx-auto rounded"
                    :class="
                      automaticProcessesStatus.normalizeMemerships.statusAA
                        ? 'btn-success'
                        : 'btn-danger'
                    "
                    @click="
                      automaticProcessesStatus.normalizeMemerships.statusAA
                        ? handleActivateMembershipsDeactivation(2)
                        : handleActivateMembershipsActivation(2)
                    "
                    :disabled="statusAAIsLoading"
                  >
                    <div
                      v-if="statusAAIsLoading"
                      class="spinner-border spinner-border-sm"
                      role="status"
                    >
                      <span class="sr-only">Loading...</span>
                    </div>
                    <i
                      v-else
                      class="fa fa-lg fa-fw"
                      :class="
                        automaticProcessesStatus.normalizeMemerships.statusAA
                          ? 'fa-refresh fa-spin'
                          : 'fa-pause'
                      "
                    ></i>
                  </button>
                </el-tooltip>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { Badge, Modal, Card } from "src/components/UIComponents";
import { Tooltip } from "element-ui";
import PSwitch from "src/components/UIComponents/Switch.vue";
export default {
  components: {
    Badge,
    Modal,
    Card,
    PSwitch,
    [Tooltip.name]: Tooltip,
  },
  data() {
    return {
      automaticProcessesStatus: {
        notifyExpiration: false,
        secondaryMembershipActivation: false,
        normalizeMemerships: {
          statusFI: false,
          statusAA: false,
          days: 0,
        },
      },
      notifyExpiration: {
        days: 0,
      },
      notifyExpirationIsLoading: false,
      secondaryMembershipActivationIsLoading: false,
      statusFIIsLoading: false,
      statusAAIsLoading: false,
    };
  },
  methods: {
    async updateDaysToActivate(data) {
      // console.log(data);
      await this.$swal.fire({
        text: "Ingresa la cantidad de días para que las membresías pagadas sean activadas",
        input: "number",
        inputPlaceholder: "Cantidad de días",
        inputAttributes: {
          min: "1",
        },
        icon: "info",
        iconHtml: '<i class="fa fa-calendar" aria-hidden="true"></i>',
        showLoaderOnConfirm: true,
        showCancelButton: true,
        confirmButtonColor: "#6bd098",
        cancelButtonColor: "#ef8157",
        inputValidator: (value) => {
          return new Promise((resolve) => {
            if (value === "" || parseInt(value) < 0 || isNaN(`${value}`)) {
              resolve(`Debes ingresar un número valido`);
            } else {
              resolve();
            }
          });
        },
        preConfirm: async (value) => {
          if (value === "" || parseInt(value) < 0 || isNaN(`${value}`)) {
            this.$swal
              .fire({
                icon: "warning",
                title: "Debes ingresar un número valido",
                showCancelButton: true,
                confirmButtonColor: "#6bd098",
                cancelButtonColor: "#ef8157",
              })
              .then((res) => {
                if (res.isConfirmed) {
                  this.updateDaysToActivate();
                }
              });
          } else if (
            parseInt(value) ===
            this.automaticProcessesStatus.normalizeMemerships.days
          ) {
            this.$swal.fire({
              icon: "success",
              title: "No fue necesario actualizar!",
              confirmButtonColor: "#6bd098",
            });
          } else {
            try {
              const newValue = parseInt(value);
              await this.$MasterControlAPP
                .post(
                  "",
                  {
                    Parameters: {
                      days: newValue,
                    },
                  },
                  {
                    headers: {
                      "Content-Type": "application/json",
                      token: sessionStorage.getItem("jCxbraoQeD"),
                      operation: "/v1/update/daystoactivate",
                    },
                  }
                )
                .then((res) => {
                  this.$swal.close();

                  if (res.data.error) {
                    this.$swal.fire({
                      title: "Error :(",
                      text:
                        "Ha ocurrido un error al actualizar el proceso automatico. " +
                        res.data.error,
                      icon: "error",
                      showConfirmButton: true,
                      confirmButtonColor: "#6bd098",
                    });
                  } else {
                    if (res.data.result === "OK") {
                      this.automaticProcessesStatus.normalizeMemerships.days =
                        newValue;
                      this.$swal.fire({
                        icon: "success",
                        title: "Exito!",
                        text: "La actualización se ha realizado con exito!",
                        confirmButtonColor: "#6bd098",
                      });
                    } else {
                      this.$swal.fire({
                        icon: "warning",
                        title: "SIN MATCH",
                        text: "No se encontró una coincidencia para la actualización",
                        confirmButtonColor: "#6bd098",
                      });
                    }
                  }
                });
            } catch (ex) {
              // console.log(ex);
              this.$swal.fire({
                title: "Error :(",
                text:
                  ex.message ||
                  "Ha ocurrido un error al desactivar el proceso automatico, ponte en contacto con soporte.",
                icon: "error",
                showConfirmButton: true,
                confirmButtonColor: "#6bd098",
              });
            }
          }
        },
      });
    },
    async updateDaysToNotifyExp(data) {
      // console.log(data);
      await this.$swal.fire({
        text: "Ingresa un numero entre 1 y 15",
        input: "number",
        inputPlaceholder: "1 - 15",
        inputAttributes: {
          min: "1",
          max: "15",
        },
        icon: "info",
        iconHtml: '<i class="fa fa-calendar" aria-hidden="true"></i>',
        showLoaderOnConfirm: true,
        showCancelButton: true,
        confirmButtonColor: "#6bd098",
        cancelButtonColor: "#ef8157",
        inputValidator: (value) => {
          return new Promise((resolve) => {
            if (value === "" || parseInt(value) < 0 || parseInt(value) > 15) {
              resolve(`Debes ingresar un número valido`);
            } else {
              resolve();
            }
          });
        },
        preConfirm: async (value) => {
          if (value === "" || parseInt(value) < 0 || parseInt(value) > 15) {
            this.$swal
              .fire({
                icon: "warning",
                title: "Debes ingresar un número valido",
                showCancelButton: true,
                confirmButtonColor: "#6bd098",
                cancelButtonColor: "#ef8157",
              })
              .then((res) => {
                if (res.isConfirmed) {
                  this.updateDaysToNotifyExp();
                }
              });
          } else if (parseInt(value) === this.notifyExpiration.days) {
            this.$swal.fire({
              icon: "success",
              title: "No fue necesario actualizar!",
              confirmButtonColor: "#6bd098",
            });
          } else {
            try {
              const newValue = parseInt(value);
              await this.$MasterControlAPP
                .post(
                  "",
                  {
                    Parameters: {
                      days: newValue,
                    },
                  },
                  {
                    headers: {
                      "Content-Type": "application/json",
                      token: sessionStorage.getItem("jCxbraoQeD"),
                      operation: "/v1/update/expnotifications",
                    },
                  }
                )
                .then((res) => {
                  this.$swal.close();

                  if (res.data.error) {
                    this.$swal.fire({
                      title: "Error :(",
                      text:
                        "Ha ocurrido un error al actualizar el proceso automatico. " +
                        res.data.error,
                      icon: "error",
                      showConfirmButton: true,
                      confirmButtonColor: "#6bd098",
                    });
                  } else {
                    // console.log(res.data);
                    if (res.data.result === "OK") {
                      this.notifyExpiration.days = newValue;
                      this.$swal.fire({
                        icon: "success",
                        title: "Exito!",
                        text: "La actualización se ha realizado con exito!",
                        confirmButtonColor: "#6bd098",
                      });
                    } else {
                      this.$swal.fire({
                        icon: "warning",
                        title: "SIN MATCH",
                        text: "No se encontró una coincidencia para la actualización",
                        confirmButtonColor: "#6bd098",
                      });
                    }
                  }
                });
            } catch (ex) {
              // console.log(ex);
              this.$swal.fire({
                title: "Error :(",
                text:
                  ex.message ||
                  "Ha ocurrido un error al desactivar el proceso automatico, ponte en contacto con soporte.",
                icon: "error",
                showConfirmButton: true,
                confirmButtonColor: "#6bd098",
              });
            }
          }
        },
      });
    },
    showInfoSwals() {
      this.$swal
        .fire({
          icon: "info",
          iconHtml: '<i class="fa fa-question" aria-hidden="true"></i>',
          title: "Recuerda!",
          text: `Los procesos automáticos solo se aplican a membresías creadas en modalidad [ON-LINE]`,
          confirmButtonText: "siguiente",
          showCancelButton: true,
          confirmButtonColor: "#6bd098",
          cancelButtonColor: "#eb6532",
        })
        .then((res) => {
          // console.log(res)
          if (res.isConfirmed) {
            this.$swal.fire({
              icon: "info",
              iconHtml: '<i class="fa fa-question" aria-hidden="true"></i>',
              title: "Recuerda!",
              html: `<p class="mb-0 text-start">Cada proceso automático tiene un intervalo de ejecución propio.</p> <p class="mt-2 text-start">Luego de activar uno, los efectos serán visibles tras su siguiente ejecución.</p>`,
              confirmButtonText: "OK",
              confirmButtonColor: "#6bd098",
            });
          }
        });
    },
    async handleAutomaticProcessActivation(automaticProcess, key) {
      // console.log("Automatic Process Activation: " + automaticProcess);
      this[`${key}IsLoading`] = true;
      try {
        await this.$MasterControlAPP
          .post(
            "",
            {
              Parameters: {
                automaticProcess: automaticProcess,
              },
            },
            {
              headers: {
                "Content-Type": "application/json",
                token: sessionStorage.getItem("jCxbraoQeD"),
                operation: "/v1/automaticprocesses/activate",
              },
            }
          )
          .then((res) => {
            this.$swal.close();

            if (res.data.error) {
              this.$swal.fire({
                title: "Error :(",
                text:
                  "Ha ocurrido un error al activar el proceso automatico. " +
                  error,
                icon: "error",
                showConfirmButton: true,
                confirmButtonColor: "#6bd098",
              });
              this[`${key}IsLoading`] = false;
            } else {
              // console.log(res.data);
              const automaticProcessesStatus = res.data.status;

              this.automaticProcessesStatus[key] = automaticProcessesStatus;
              this[`${key}IsLoading`] = false;
            }
          });
      } catch (ex) {
        // console.log(ex);
        this.$swal.fire({
          title: "Error :(",
          text:
            ex.message ||
            "Ha ocurrido desactivar el proceso automatico, ponte en contacto con soporte.",
          icon: "error",
          showConfirmButton: true,
          confirmButtonColor: "#6bd098",
        });
      }
    },
    async handleAutomaticProcessDeactivation(automaticProcess, key) {
      // console.log("Automatic Process Deactivation: " + automaticProcess);
      this[`${key}IsLoading`] = true;
      try {
        await this.$MasterControlAPP
          .post(
            "",
            {
              Parameters: {
                automaticProcess: automaticProcess,
              },
            },
            {
              headers: {
                "Content-Type": "application/json",
                token: sessionStorage.getItem("jCxbraoQeD"),
                operation: "/v1/automaticprocesses/deactivate",
              },
            }
          )
          .then((res) => {
            this.$swal.close();

            if (res.data.error) {
              this.$swal.fire({
                title: "Error :(",
                text:
                  "Ha ocurrido un error al desactivar el proceso automatico. " +
                  error,
                icon: "error",
                showConfirmButton: true,
                confirmButtonColor: "#6bd098",
              });
              this[`${key}IsLoading`] = false;
            } else {
              // console.log(res.data);
              const automaticProcessesStatus = res.data.status;

              this.automaticProcessesStatus[key] = automaticProcessesStatus;
              this[`${key}IsLoading`] = false;
            }
          });
      } catch (ex) {
        // console.log(ex);
        this.$swal.fire({
          title: "Error :(",
          text:
            ex.message ||
            "Ha ocurrido un error al desactivar el proceso automatico, ponte en contacto con soporte.",
          icon: "error",
          showConfirmButton: true,
          confirmButtonColor: "#6bd098",
        });
      }
    },
    async handleActivateMembershipsActivation(processOption) {
      // console.log("Automatic Process Activation: " + processOption);
      let subProcessName = "";
      switch (processOption) {
        case 1:
          subProcessName = "statusFI";
          break;
        case 2:
          subProcessName = "statusAA";
          break;
        default:
          break;
      }
      this[`${subProcessName}IsLoading`] = true;
      try {
        await this.$MasterControlAPP
          .post(
            "",
            {
              Parameters: {
                process: processOption,
              },
            },
            {
              headers: {
                "Content-Type": "application/json",
                token: sessionStorage.getItem("jCxbraoQeD"),
                operation: "/v1/automaticprocesses/autoactivation/activate",
              },
            }
          )
          .then((res) => {
            this.$swal.close();

            if (res.data.error) {
              this.$swal.fire({
                title: "Error :(",
                text:
                  "Ha ocurrido un error al activar el proceso automatico. " +
                  res.data.error,
                icon: "error",
                showConfirmButton: true,
                confirmButtonColor: "#6bd098",
              });
              this[`${subProcessName}IsLoading`] = false;
            } else {
              const automaticProcessesStatus = res.data.status;

              this.automaticProcessesStatus.normalizeMemerships[
                subProcessName
              ] = automaticProcessesStatus;
              this[`${subProcessName}IsLoading`] = false;
            }
          });
      } catch (ex) {
        // console.log(ex);
        this.$swal.fire({
          title: "Error :(",
          text:
            ex.message ||
            "Ha ocurrido desactivar el proceso automatico, ponte en contacto con soporte.",
          icon: "error",
          showConfirmButton: true,
          confirmButtonColor: "#6bd098",
        });
      }
    },
    async handleActivateMembershipsDeactivation(processOption) {
      // console.log("adsads");
      // console.log("Automatic Process Activation: " + processOption);
      let subProcessName = "";
      switch (processOption) {
        case 1:
          subProcessName = "statusFI";
          break;
        case 2:
          subProcessName = "statusAA";
          break;
        default:
          break;
      }
      this[`${subProcessName}IsLoading`] = true;
      try {
        await this.$MasterControlAPP
          .post(
            "",
            {
              Parameters: {
                process: processOption,
              },
            },
            {
              headers: {
                "Content-Type": "application/json",
                token: sessionStorage.getItem("jCxbraoQeD"),
                operation: "/v1/automaticprocesses/autoactivation/deactivate",
              },
            }
          )
          .then((res) => {
            this.$swal.close();

            if (res.data.error) {
              this.$swal.fire({
                title: "Error :(",
                text:
                  "Ha ocurrido un error al activar el proceso automatico. " +
                  res.data.error,
                icon: "error",
                showConfirmButton: true,
                confirmButtonColor: "#6bd098",
              });
              this[`${subProcessName}IsLoading`] = false;
            } else {
              // console.log(res.data);
              const automaticProcessesStatus = res.data.status;

              this.automaticProcessesStatus.normalizeMemerships[
                subProcessName
              ] = automaticProcessesStatus;
              this[`${subProcessName}IsLoading`] = false;
            }
          });
      } catch (ex) {
        // console.log(ex);
        this.$swal.fire({
          title: "Error :(",
          text:
            ex.message ||
            "Ha ocurrido desactivar el proceso automatico, ponte en contacto con soporte.",
          icon: "error",
          showConfirmButton: true,
          confirmButtonColor: "#6bd098",
        });
      }
    },
    async getAutomaticProcessesStatus() {
      this.$swal.fire({
        title: "Cargando...",
        text: "Esto puede tomar unos segundos",
        allowOutsideClick: false,
        confirmButtonColor: "#6bd098",
        didOpen: () => {
          this.$swal.showLoading();
        },
      });

      try {
        await this.$MasterControlAPP
          .post(
            "",
            {
              Parameters: {},
            },
            {
              headers: {
                "Content-Type": "application/json",
                token: sessionStorage.getItem("jCxbraoQeD"),
                operation: "/v1/get/automaticprocesses/status",
              },
            }
          )
          .then((res) => {
            this.$swal.close();
            if (res.data.error) {
              this.$swal
                .fire({
                  title: "Error :(",
                  text: "Ha ocurrido un error al recuperar tus configuraciones, ponte en contacto con soporte.",
                  icon: "error",
                  showConfirmButton: true,
                })
                .then((res) => {
                  this.notifyExpirationIsLoading = true;
                  this.secondaryMembershipActivationIsLoading = true;
                });
            } else {
              // console.log(res.data.result);
              const automaticProcessesStatus = res.data.result;
              this.automaticProcessesStatus.notifyExpiration =
                automaticProcessesStatus.notifyExpiration.status;
              this.notifyExpiration.days =
                automaticProcessesStatus.notifyExpiration.days;

              this.automaticProcessesStatus.normalizeMemerships.statusAA =
                automaticProcessesStatus.normalizeMemerships.statusAA; // Status Activación Automática
              this.automaticProcessesStatus.normalizeMemerships.days =
                automaticProcessesStatus.normalizeMemerships.days; // Cantidad de días para activar membresías pagadas

              this.automaticProcessesStatus.normalizeMemerships.statusFI =
                automaticProcessesStatus.normalizeMemerships.statusFI; //Status Activación por Fecha Inicio

              this.automaticProcessesStatus.secondaryMembershipActivation =
                automaticProcessesStatus.actSecondaryMemberships.status;
            }
          });
      } catch (ex) {
        // console.log(ex);
        // this.$swal.close()
        this.$swal
          .fire({
            title: "Error :(",
            text:
              ex.message ||
              "Ha ocurrido un error al recuperar tus configuraciones, ponte en contacto con soporte.",
            icon: "error",
            showConfirmButton: true,
          })
          .then((res) => {
            this.notifyExpirationIsLoading = true;
            this.secondaryMembershipActivationIsLoading = true;
          });
      }
    },
  },
  async mounted() {
    await this.getAutomaticProcessesStatus();
  },
  async beforeMount() {
    this.$swal.close();
  },
};
</script>

<style>
.info-ico {
  font-size: 20px;
  cursor: pointer;
}
.info-ico:hover {
  font-size: 22px;
  cursor: pointer;
}
@keyframes pulseAnimation {
  0%,
  100% {
    opacity: 0.6;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.1);
  }
}

.pulse-animation {
  animation: pulseAnimation 1.5s ease-in-out infinite;
}
.pulse-animation:hover {
  animation: none;
}

.card-notificationdays {
  width: 70px;
  height: 70px;
  border-radius: 8px;
  box-shadow: 0px 1px 3px #343a409a inset;
}
.card-notificationdays:hover {
  cursor: pointer;
  text-shadow: 2px 2px 4px #343a409a;
}
.card-notificationdays--disabled {
  width: 70px;
  height: 70px;
  border-radius: 8px;
  box-shadow: 0px 1px 3px #343a409a inset;
}
.card-activationdays {
  min-width: 50px;
  height: 50px;
  border-radius: 8px;
  box-shadow: 0px 1px 3px #343a409a inset;
}
.card-activationdays:hover {
  cursor: pointer;
  text-shadow: 2px 2px 4px #343a409a;
}
.card-activationdays--disabled {
  min-width: 50px;
  max-width: 70px;
  height: 50px;
  border-radius: 8px;
  box-shadow: 0px 1px 3px #343a409a inset;
}
</style>
